import { NgModule } from '@angular/core';

import { SpinnerSharedComponent } from './spinner.component';

import { IconSharedModule } from '../icon/icon.module';

@NgModule({
    declarations: [
        SpinnerSharedComponent
    ],
    imports: [
        IconSharedModule
    ],
    exports: [
        SpinnerSharedComponent
    ]
})

export class SpinnerSharedModule {}
